import { useState } from 'react'
import { LocalStorage } from "../../services/localStorage/LocalStorage.services"
import { NavLink } from 'react-router-dom'
import {
    DesktopOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    PieChartOutlined,
    SettingOutlined,
    TeamOutlined,
    TagsOutlined,
    HomeOutlined,
    ShopOutlined,
    GlobalOutlined,
    ClusterOutlined,
    CalendarOutlined
} from '@ant-design/icons'
import { Button, Menu, ConfigProvider } from 'antd'

import styles from './NavBar2.module.css'

const NavBar2 = (props) => {

    const [collapsed, setCollapsed] = useState(true)
    
    const toggleCollapsed = () => {
        setCollapsed(!collapsed)
    }

    const items = [
        {
            key: '/home',
            icon: <PieChartOutlined />,
            label: <NavLink to="/home" onClick={() => setCollapsed(true)}>Home</NavLink>
        },
        {
            key: 'sub1',
            label: 'Tasques',
            icon: <DesktopOutlined />,
            children: [
                {
                    key: '/tasques/daily',
                    icon: <GlobalOutlined />,
                    label: <NavLink to="/tasques/daily" onClick={() => setCollapsed(true)}>Daily</NavLink>
                },
                {
                    key: '/tasques/calendari',
                    icon: <CalendarOutlined />,
                    label: <NavLink to="/tasques/calendari" onClick={() => setCollapsed(true)}>Calendari</NavLink>
                },
                {
                    key: '/tasques',
                    icon: <DesktopOutlined />,
                    label: <NavLink to="/tasques" onClick={() => setCollapsed(true)}>Tasques</NavLink>
                },
            ],
        },
        {
            key: 'sub2',
            label: 'Configuració',
            icon: <SettingOutlined />,
            children: [
                {
                    key: '/professionals',
                    icon: <TeamOutlined />,
                    label: <NavLink to="/professionals" onClick={() => setCollapsed(true)}>Professionals</NavLink>
                },
                {
                    key: '/etiquetes',
                    icon: <TagsOutlined />,
                    label: <NavLink to="/etiquetes" onClick={() => setCollapsed(true)}>Etiquetes</NavLink>
                },
                LocalStorage.getItem('professionalProfile') === "Superadministrador" &&
                    {
                        key: '/tipus',
                        icon: <ClusterOutlined />,
                        label: <NavLink to="/tipus" onClick={() => setCollapsed(true)}>Tipus</NavLink>
                    },
                {
                    key: '/projectes',
                    icon: <ShopOutlined />,
                    label: <NavLink to="/projectes" onClick={() => setCollapsed(true)}>Projectes</NavLink>
                },
                LocalStorage.getItem('professionalProfile') === "Superadministrador" &&
                    {
                        key: '/empreses',
                        icon: <HomeOutlined />,
                        label: <NavLink to="/empreses" onClick={() => setCollapsed(true)}>Empreses</NavLink>
                    },
                LocalStorage.getItem('professionalProfile') === "Superadministrador" &&
                    {
                        key: '/serveis',
                        icon: <HomeOutlined />,
                        label: <NavLink to="/serveis" onClick={() => setCollapsed(true)}>Àrees</NavLink>
                    },
            ],
        },
    ]

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#556892',
                },
            }}
        >
            <div className={styles.container}>
                <Button
                    type="primary"
                    onClick={toggleCollapsed}
                    className={styles.button}
                >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </Button>
                <Menu
                    defaultSelectedKeys={['/home']}
                    mode="inline"
                    theme="dark"
                    inlineCollapsed={collapsed}
                    items={items}
                    className={styles.menu}
                />
            </div>
        </ConfigProvider>
    )
}

export default NavBar2